import { Component } from '@angular/core';
import {CardModule} from "primeng/card";

@Component({
  selector: 'app-simple-responsive-frame',
  standalone: true,
  imports: [
    CardModule
  ],
  templateUrl: './simple-responsive-frame.component.html',
    styleUrls: ['./simple-responsive-frame.component.scss']
})
export class SimpleResponsiveFrameComponent {

}
